import type { CampaignHeroModuleFragment } from 'bundles/campaigns/queries/__generated__/HeroModuleFragment';
import type { HeroBannerPromoCardType } from 'bundles/front-page/redesign-modules/hero-banner/HeroBannerPromoCard';
import getPredefinedPromos from 'bundles/front-page/redesign-modules/hero-banner/data/getPredefinedPromos';

const getHeroBannerPromos = (campaignHeroModule?: CampaignHeroModuleFragment): Array<HeroBannerPromoCardType> => {
  const predefinedPromos = getPredefinedPromos();

  let campaignHeroBannerPromo: HeroBannerPromoCardType | undefined;
  if (campaignHeroModule?.contentDataJson) {
    const {
      description,
      backgroundColor,
      ctaText,
      ctaTarget,
      headline,
      eyebrow,
      eyebrowBackground,
      eyebrowImage,
      image,
      imageMobile,
    } = campaignHeroModule.contentDataJson || {};
    const eyebrowImageHeight = eyebrowImage?.height ? Math.min(eyebrowImage.height, 16) : undefined;
    campaignHeroBannerPromo = {
      backgroundColor,
      eyebrow: {
        label: eyebrow,
        backgroundColor: eyebrowBackground,
        image: {
          ...eyebrowImage,
          height: eyebrowImageHeight,
        },
      },
      headline,
      description,
      desktopImage: image,
      mobileImage: imageMobile,
      cta: {
        target: ctaTarget,
        label: ctaText,
      },
      campaignEventingData: {
        id: campaignHeroModule?.campaignId ?? '',
        matchedCountryCode: campaignHeroModule?.matchedCountryCode ?? '',
        epicExperimentId: campaignHeroModule?.epicExperimentId ?? '',
        regionName: campaignHeroModule?.regionName ?? '',
        name: campaignHeroModule?.campaignName ?? '',
      },
    };
  }

  if (campaignHeroBannerPromo) {
    return [campaignHeroBannerPromo, predefinedPromos.wesTentpole, predefinedPromos.joinForFree].filter(Boolean);
  }

  return [predefinedPromos.joinForFree, predefinedPromos.c4b, predefinedPromos.promoCert].filter(Boolean);
};

export default getHeroBannerPromos;
